var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimRowReturned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 4h12c.5522847 0 1 .44771525 1 1v14c0 .5522847-.4477153 1-1 1h-12c-.55228475 0-1-.4477153-1-1v-14c0-.55228475.44771525-1 1-1zm1 3v1h5v-1zm0 5v1h10v-1zm0 2v1h9v-1zm0 2v1h5v-1z",
    fill: "#b197fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    fill: "#845ef7",
    r: 8,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5833515 6.50010889c.9667718 0 1.7499891.6713153 1.7499891 1.50013417 0 .82811887-.7832173 1.49943416-1.7499891 1.49943416-.3219979 0-.5833296.2240051-.5833296.50051138 0 .2758063.2613317.4998114.5833296.4998114 1.6107678 0 2.9166485-1.11932549 2.9166485-2.49975694 0-1.38113145-1.3058807-2.50045695-2.9166485-2.50045695h-2.1902085l1.092771-1.1900271c.1998876-.21700495.1555545-.53201212-.0972217-.70281601-.2550427-.17027021-.6130576-.13354966-.8189949.08400191l-1.9444323 2.11754823c-.1747238.18733006-.1656928.46278309.0209999.64051459l1.9444323 1.88304289c.2195075.20748448.5803193.22586599.8244393.04200096.1152573-.08496824.1860824-.20923547.1955228-.34305724.0094405-.13382176-.0433536-.26515315-.1457453-.36255883l-1.2071036-1.16902663z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRowReturned);
export default __webpack_public_path__ + "static/media/claim-row-returned.6b38d7b7cadefe227a9e308669a495ac.svg";
export { ForwardRef as ReactComponent };